<template>
  <el-form ref="form"  v-bind="formData.formProps"   v-on="formEvents" v-if="isShowForm">
    <QS-search maxLine="1" :baseHeight="64" v-if="type==='search'" ref="blmSearch">
      <!-- eslint-disable vue/no-mutating-props -->
      <base-form-item
        ref="baseFormItem"
        :list.sync="list"
        :model.sync="formData.formProps.model">
      </base-form-item>
      <template slot="moreBtn"><slot></slot></template>
    </QS-search>
    <base-form-item
      ref="baseFormItem"
      :list="list"
      :model.sync="formData.formProps.model" v-else>
    </base-form-item>
  </el-form>
</template>
<script>
import set from 'lodash/set'
import merge from 'lodash/merge'
import BaseFormItem from './BaseFormItem'
import { optionDefault } from './config'

export default {
  name: 'BaseForm',
  props: ['formData'],
  data() {
    // 维护一套model数据（this.formData.formProps和this.formData.formProps.model)
    const { list = [], formEvents = {}, type = 'search' } = this.formData
    return {
      list,
      formEvents,
      type,
    }
  },
  components: {
    BaseFormItem,
  },
  computed: {
    isShowForm() {
      const { formData: { list } } = this
      return !!(list && Array.isArray(list) && list.length > 0)
    },
  },
  created() {
    // this.$set保持对象数据地址的一致，改变搜索项，成功赋值，如果用this.formData.xx={}不能刷新页面赋值
    const { formProps } = this.formData
    if (!formProps) {
      this.$set(this.formData, 'formProps', {})
    }
    // props mode 覆盖 defaultModel
    if (Array.isArray(this.list)) {
      const defaultModel = {}
      this.list.forEach((l) => {
        set(
          defaultModel,
          l.itemConfig.prop,
          l.elConfig?.defaultValue ?? (optionDefault[l.el]?.defaultValue ?? ''),
        )
      })
      const model = merge(defaultModel, this.formData?.formProps?.model || {})
      this.$set(this.formData.formProps, 'model', model)
    }
  },
  methods: {
    // 表单校验，有rule内容则校验
    // eslint-disable-next-line vue/no-unused-properties
    validate() {
      this.$refs[this.ref || 'form'].validate((valid) => {
        if (valid) {
          this.$emit('cb')
        }
      })
    },
    // 重置
    // eslint-disable-next-line vue/no-unused-properties
    reset() {
      this.$refs[this.ref || 'form'].resetFields()
    },
  },
}
</script>
